module.exports = __webpack_public_path__ + "static/media/products.5a4fcfdc.svg";